import { ESTADO_COLUMN } from "features/Documentos/constants"
import { nanoid } from "nanoid"

import { ESTADO_REVISION_DOCUMENTO_FILTERS } from "../../../common/utils/constants"
import {
  ActionsAlbaranBodyTemplate,
  CIFBodyTemplate,
  ClienteBodyTemplate,
  EstadosBodyTemplate,
  FechaBodyTemplate,
  ImporteBodyTemplate,
  NumFacturaBodyTemplate,
  NumeroArchivosAdjuntosTemplate,
  TipoEstadoMultiselectBodyTemplate,
} from "../templates"

export const albaranesColumns = (
  tabSelected: $TSMigrationFixMe,
  t: $TSMigrationFixMe
) => [
  {
    key: nanoid(),
    header: `${t("crear.albaran.tab.headerNumOrder")}`,
    sortable: true,
    body: NumFacturaBodyTemplate,
    filter: false,
    field: "numero",
    customFilter: {
      type: "input",
      name: "SerieNumero",
    },
  },
  {
    key: nanoid(),
    header: `${t("crear.albaran.tab.headerCompanyName")}`,
    sortable: true,
    filter: false,
    body: ClienteBodyTemplate,
    field: "Librado.RazonSocial",
    customFilter: {
      type: "input",
      name: "RazonSocialLibrado",
    },
  },
  {
    key: nanoid(),
    header: `${t("crear.albaran.tab.headerNif")}`,
    sortable: true,
    filter: false,
    body: CIFBodyTemplate,
    field: "Librado.Nif",
    customFilter: {
      type: "input",
      name: "NifLIbrado",
    },
  },
  {
    key: nanoid(),
    header: `${t("crear.albaran.tab.headerEmisionDate")}`,
    sortable: true,
    filter: false,
    body: FechaBodyTemplate,
    field: "fechaEmision",
    customFilter: {
      type: "date",
      name: "fechaEmision",
    },
  },
  {
    key: nanoid(),
    header: `${t("crear.albaran.tab.headerImport")}`,
    sortable: true,
    body: ImporteBodyTemplate,
    field: "importe",
  },

  {
    key: ESTADO_COLUMN,
    header: `${t("crear.albaran.tab.headerState")}`,
    sortable: true,
    body: (rowData: $TSMigrationFixMe) => EstadosBodyTemplate(rowData, t),
    field: "estadoRevisionActual",
    headerStyle: {
      width: 150,
    },
    className: "estadoRevisionActual",
    filter: false,
    customFilter: {
      type: "select",
      options: ESTADO_REVISION_DOCUMENTO_FILTERS(t),
      name: "estadoRevision",
      placeholder: "Tipo de Estado",
      itemTemplate: TipoEstadoMultiselectBodyTemplate,
    },
  },
  {
    key: nanoid(),
    header: `${t("crear.albaran.tab.headerAdjArc")}`,
    className: "archivosAdjuntos",
    body: NumeroArchivosAdjuntosTemplate,
    isFunctionComponent: true,
    headerStyle: {
      width: 80,
    },
  },
  {
    key: nanoid(),
    body: (rowData: $TSMigrationFixMe) =>
      ActionsAlbaranBodyTemplate(rowData, tabSelected),
    className: "actionsPresupuesto",
    isFunctionComponent: true,
    headerStyle: {
      width: 40,
    },
  },
]
